import { mediaHelper, rem } from '@affstore-ds/uikit'
import { createStyles } from '@mantine/emotion'

export const useLanguageDropdownStyles = createStyles(() => ({
  targetElement: {
    '&&': {
      [`${mediaHelper.greaterThen('lg')}`]: {
        padding: rem(8),
      },
      padding: rem(4),
    },
  },
  targetElementLabel: {
    [`${mediaHelper.greaterThen('lg')}`]: {
      marginInline: rem(8),
    },
    marginInline: rem(4),
  },
  targetElementSection: {
    '&&[data-position=left]': {
      marginInlineEnd: rem(0),
    },
    '&&[data-position=right]': {
      marginInlineStart: rem(0),
    },
  },
}))
